export const MUNICIPALITIES = [
  "Aalborg",
  "Hjørring",
  "Jammerbugt",
  "Frederikshavn",
  "Brønderslev-Dronninglund",
];

export const YEARS = Array.from(
  { length: new Date().getFullYear() - 2021 + 1 },
  (_, i) => 2021 + i
);

export const MONTHS = [
  "Januar",
  "Februar",
  "Marts",
  "April",
  "Maj",
  "Juni",
  "Juli",
  "August",
  "September",
  "Oktober",
  "November",
  "December",
];
